import { sparklingHr } from '../../utils/effectUtils';
import './../components/presentation_styles.css';
import { ef } from '../../utils/effectUtils';

function PresentationHeader() {

    const styles = {
        head:{
            paddingTop: 20,
        },
        brandTitle:{
            marginBottom: 30,
            fontSize: 16,
            fontWeight: 700,
            textAlign: 'center'
        },
        brandTitleDot:{
            color: '#00a924',
            fontSize: 30,
        },
        hr:{
            margin: 0,
            borderBottom: '4px solid #00a924'
        },
        logoWrap:{
            position: 'relative',
            top: -33,
            textAlign: 'center'
        },
        logo:{
            width: 60
        },
    }

    return (
        <div style={styles.head}>
            <h4 style={styles.brandTitle}>CAREER BIG BRO<span style={styles.brandTitleDot}>.</span></h4>
            {sparklingHr()}
            <div style={styles.logoWrap}>
                {ef(<img src='/images/logo-lg.png' style={styles.logo} />, 'zoom')}
            </div>
        </div>
    )

}

export default PresentationHeader;

